import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from 'i18next';
import { useParams } from 'react-router-dom';

import Favorite from '@mui/icons-material/Favorite';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import FlagIcon from '@mui/icons-material/Flag';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import { getMenuItems, SocialShare, useIsMyLearningEnabled } from '@/exceed';

import styles from '../styles/videoContentActions.module.scss';

const VideoContentActions = ({
  dropEnrollment = () => null,
  favouriteVideo = () => null,
  is_enrolled: isEnrolled = false,
  is_favorited: isFavorited = false,
  reportVideo = () => null,
  title = '',
  unfavouriteVideo = () => null,
}) => {
  const { type } = useParams();
  const isMyLearningEnabled = useIsMyLearningEnabled();

  return (
    <div className={styles.container}>
      <Button
        className={`${styles.button} ${styles.action}`}
        icon={isFavorited ? <Favorite /> : <FavoriteBorder />}
        onClick={isFavorited ? unfavouriteVideo : favouriteVideo}
        text={isMyLearningEnabled ? null : i18n.t('favorites')}
        variant={isMyLearningEnabled ? 'ghost' : 'link'}
        size="xsmall"
        iconSize={18}
      />
      <SocialShare buttonClassName={classNames(styles.button, styles.action)} pageTitle={title} />

      {isMyLearningEnabled && (
        <Menu
          className={styles.element}
          shouldAnimate={false}
          horizontalPosition="left"
          component={
            <Button
              size="xsmall"
              variant="ghost"
              icon={<MoreHoriz />}
              aria-label={i18n.t('learning-objectives.toggle-options-menu')}
            />
          }
        >
          {getMenuItems(
            [
              {
                className: classNames({ [styles.isDisabled]: !isEnrolled }),
                isDisabled: !isEnrolled,
                icon: <RemoveCircleOutlineIcon />,
                iconClassName: styles.icon,
                key: 'drop-enrollment',
                onClick: dropEnrollment,
              },
              {
                icon: <FlagIcon />,
                iconClassName: styles.icon,
                key: 'report',
                onClick: reportVideo,
              },
            ].filter(Boolean),
          )}
        </Menu>
      )}
    </div>
  );
};

VideoContentActions.propTypes = {
  dropEnrollment: PropTypes.func,
  favouriteVideo: PropTypes.func,
  is_enrolled: PropTypes.bool,
  is_favorited: PropTypes.bool,
  reportVideo: PropTypes.func,
  title: PropTypes.string,
  unfavouriteVideo: PropTypes.func,
};

export default React.memo(VideoContentActions);
